import dynamic from 'next/dynamic';

const ThumbnailCarousel = {
  getSettings: componentSettings => ({
    ...componentSettings
  }),
  VariantComponent: dynamic(() =>
    import(/* webpackChunkName: "blazePbVariantThumbnailCarousel" */ './ThumbnailCarousel')
  )
};

export default ThumbnailCarousel;
